import axios from 'axios'

// 创建一个 axios 实例
const apiInstance = axios.create({
  baseURL: 'https://myd-api.iscn.org.cn', // 正式
  // baseURL: 'https://myd-test.iscn.org.cn', // 测试
})

export default apiInstance



// WEBPACK FOOTER //
// ./src/utils/request.js